import { ALL_EMOJIS } from "@/lib/emojiSets";

// Shared emoji sets + emoji-only message helpers (TikTok-style jumbo, no bubble).

export const REACT_EMOJIS = ["🙏", "❤️", "👍", "😂", "😮", "😢"];

export const EMOJIS = ALL_EMOJIS; // lot 634 — 3 catégories (lib/emojiSets)

const EMOJI_PICTO = /\p{Extended_Pictographic}/u;
export const isEmojiOnly = (s) => {
  if (!s) return false;
  const t = s.trim();
  if (!t || /[\p{L}\p{N}]/u.test(t)) return false;
  return EMOJI_PICTO.test(t);
};
export const emojiCount = (s) => ((s || "").match(/\p{Extended_Pictographic}/gu) || []).length;
export const emojiFontSize = (n) => (n <= 1 ? 60 : n <= 2 ? 50 : n <= 3 ? 42 : n <= 6 ? 32 : 24);
